import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useWebAuthnRegister } from '@/hooks/useWebAuthnRegister'

function RegisterPage() {
    const navigate = useNavigate()
    const { register, loading } = useWebAuthnRegister()
    const [username, setUsername] = useState('')
    const [status, setStatus] = useState<'idle' | 'success' | 'error'>('idle')
    const [errorMsg, setErrorMsg] = useState('')

    const handleRegister = async (e: React.FormEvent) => {
        e.preventDefault()
        if (!username) return

        const result = await register(username)
        if (result.success) {
            setStatus('success')
            // Optional: redirect after success
            // setTimeout(() => navigate('/auth'), 2000)
        } else {
            setStatus('error')
            setErrorMsg(result.error || 'Registration failed')
        }
    }

    return (
        <div className="min-h-screen bg-gray-900 flex items-center justify-center p-6">
            <div className="bg-white rounded-2xl shadow-xl max-w-md w-full p-8">
                <div className="text-center mb-8">
                    <h2 className="text-2xl font-bold text-gray-900">Register New Key</h2>
                    <p className="text-gray-500 mt-2">Add a security key to your account</p>
                </div>

                {status === 'success' ? (
                    <div className="text-center">
                        <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                            <i className="iconoir-check text-green-600 text-3xl"></i>
                        </div>
                        <h3 className="text-xl font-bold text-gray-900 mb-2">Success!</h3>
                        <p className="text-gray-500 mb-6">Your security key has been registered.</p>
                        <button
                            onClick={() => navigate('/auth')}
                            className="w-full bg-yubico-green-500 hover:bg-yubico-green-600 text-white font-bold py-3 px-4 rounded-lg transition-colors"
                        >
                            Go to Login
                        </button>
                    </div>
                ) : (
                    <form onSubmit={handleRegister} className="space-y-6">
                        <div>
                            <label htmlFor="username" className="block text-sm font-medium text-gray-700 mb-1">
                                Username
                            </label>
                            <input
                                type="text"
                                id="username"
                                value={username}
                                onChange={(e) => setUsername(e.target.value)}
                                className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-yubico-green-500 focus:border-transparent transition-all outline-none"
                                placeholder="Enter username"
                                required
                                autoFocus
                            />
                        </div>

                        {status === 'error' && (
                            <div className="p-4 bg-red-50 text-red-700 rounded-lg text-sm">
                                {errorMsg}
                            </div>
                        )}

                        <button
                            type="submit"
                            disabled={loading || !username}
                            className={`w-full font-bold py-3 px-4 rounded-lg transition-colors flex items-center justify-center gap-2 ${loading || !username
                                ? 'bg-gray-100 text-gray-400 cursor-not-allowed'
                                : 'bg-yubico-green-500 hover:bg-yubico-green-600 text-white'
                                }`}
                        >
                            {loading ? (
                                <>
                                    <span className="w-5 h-5 border-2 border-white/30 border-t-white rounded-full animate-spin" />
                                    <span>Registering...</span>
                                </>
                            ) : (
                                'Register Key'
                            )}
                        </button>

                        <button
                            type="button"
                            onClick={() => navigate('/auth')}
                            className="w-full text-gray-500 hover:text-gray-700 text-sm font-medium"
                        >
                            Back to Login
                        </button>
                    </form>
                )}
            </div>
        </div>
    )
}

export default RegisterPage
